export default "__VITE_ASSET__D6uc2Rle__"